import React from "react";

const InactivityModal = ({
  id,
  isModalOpen,
  closeModal,
  handleLogout,
  continueSession,
  countdown,
}) => {
  return (
    <>
      <div
        id={id}
        className={`${
          isModalOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-[50%] mx-auto">
            <div className="mb-5 mx-auto flex flex-col items-center justify-center">
              <div className="flex items-center justify-between w-full mt-2 mr-2">
                <button
                  onClick={continueSession}
                  type="button"
                  className="bg-transparent rounded-lg text-sm ml-auto inline-flex items-center"
                  data-modal-toggle={id}
                >
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="1.35355"
                      y1="0.646447"
                      x2="18.6487"
                      y2="17.9416"
                      stroke="black"
                    />
                    <line
                      y1="-0.5"
                      x2="24.459"
                      y2="-0.5"
                      transform="matrix(-0.707107 0.707107 0.707107 0.707107 18.2949 1)"
                      stroke="black"
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                </button>
              </div>
              <div className="flex flex-col items-center mx-5 text-center">
                <div className="py-2">
                  <div className="text-[#000000] text-[20px] font-[600] mt-2">
                    <p>You Will Be Logged Out Soon</p>
                  </div>
                  <div className="text-[#000000] text-[12px] font-normal mt-2">
                    <p>
                      For your safety and to protect your account, we
                      automatically log you out
                      <br /> after a period of inactivity.
                    </p>
                  </div>
                  <div className="mt-2">
                    <p className="text-[#000000] text-[32px] font-[600] mt-2">
                      00:{countdown}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex items-center mt-5">
                <div className="mr-2">
                  <button
                    onClick={handleLogout}
                    data-modal-toggle={id}
                    type="button"
                    className="text-[#005C53] w-[228px] bg-transparent hover:bg-transparent focus:outline-none font-[500] rounded-[5px] text-md px-5 py-2 text-center border border-[#005C53]"
                  >
                    Log Out Now
                  </button>
                </div>
                <button
                  onClick={continueSession}
                  data-modal-toggle={id}
                  type="button"
                  className="text-[#FFFFFF] w-[228px] hover:bg-[#005C53] focus:outline-none font-[500] rounded-[5px] text-md px-5 py-2 text-center bg-[#005C53] border border-[#005C53]"
                >
                  Continue Session
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InactivityModal;
